import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box
} from '@mui/material';
import { shades } from '../../../../theme.js';

const AddGroupDialog = ({ open, onClose, onSubmit }) => {
  const [groupData, setGroupData] = useState({
    name: '',
    description: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGroupData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = () => {
    onSubmit(groupData);
    setGroupData({ name: '', description: '' });
    onClose();
  };

  const isFormValid = groupData.name.trim() !== '' && groupData.description.trim() !== '';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '100%',
          maxWidth: '500px',
          backgroundColor: '#fff'
        }
      }}
    >
      <DialogTitle sx={{
        color: shades.neutral[700],
        fontWeight: 'bold'
      }}
      >
        Create New Group
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <TextField
            autoFocus
            name='name'
            label='Group Name'
            fullWidth
            value={groupData.name}
            onChange={handleChange}
            sx={{
              mb: 3,
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: shades.neutral[700]
                },
                '&:hover fieldset': {
                  borderColor: 'black'
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'black'
                }
              },
              '& .MuiInputBase-input': {
                color: shades.neutral[900]
              },
              '& .MuiInputLabel-root': {
                color: 'darkgray'
              },
              '& .MuiInputLabel-root': {
                color: shades.neutral[700],
                '&.Mui-focused': {
                  color: 'black'
                }
              }
            }}
          />
          <TextField
            name='description'
            label='Description'
            fullWidth
            multiline
            rows={4}
            value={groupData.description}
            onChange={handleChange}
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: shades.neutral[700]
                },
                '&:hover fieldset': {
                  borderColor: 'black'
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'black'
                }
              },
              '& .MuiInputBase-input': {
                color: shades.neutral[900]
              },
              '& .MuiInputLabel-root': {
                color: 'darkgray'
              },
              '& .MuiInputLabel-root': {
                color: shades.neutral[700],
                '&.Mui-focused': {
                  color: 'black'
                }
              }
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button
          onClick={onClose}
          sx={{
            color: shades.neutral[700],
            borderColor: shades.neutral[700],
            '&:hover': {
              backgroundColor: shades.neutral[100],
              borderColor: 'black',
              color: 'black'
            }
          }}
          variant='outlined'
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          disabled={!isFormValid}
          sx={{
            backgroundColor: 'black',
            color: 'white',
            '&:hover': {
              backgroundColor: '#333'
            },
            '&:disabled': {
              backgroundColor: shades.neutral[500],
              color: 'white'
            }
          }}
          variant='contained'
        >
          Create Group
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddGroupDialog;
